import { useEffect, useRef } from 'react';

import { useAuthStatus, useIsAuth } from '#modules/user/features/auth/hooks/useIsAuth';

import { reportTaggedLanding, taggedLandingFrom } from '../utils/taggedLanding';

/**
 * Отмечает, что человек без аккаунта открыл сайт по размеченной ссылке (например, из карточки
 * бота в Discord). Один раз на загрузку: переходы внутри сайта уже не приход по ссылке.
 *
 * Ждёт, пока проверка входа закончится: пока статус «pending» или «error», мы не знаем, есть ли
 * у человека аккаунт, а посчитать вошедшего как новичка — значит соврать в воронке.
 */
export const useTaggedLanding = () => {
  const isAuth = useIsAuth();
  const authStatus = useAuthStatus();
  const done = useRef(false);

  useEffect(() => {
    if (done.current || authStatus !== 'ok') {
      return;
    }
    done.current = true;

    if (isAuth) {
      return;
    }

    const landing = taggedLandingFrom(window.location.search, window.location.pathname);

    if (landing) {
      void reportTaggedLanding(landing);
    }
  }, [authStatus, isAuth]);
};
